import React, { useEffect } from "react";
import Main_Page from "../Main_Page";
import {
	Page,
	Card,
	Stack,
	Layout,
	Icon,
	Heading,
	Link,
} from "@shopify/polaris";
import { ChevronDownMinor } from "@shopify/polaris-icons";
import $ from "jquery";

export default function Index() {
	useEffect(() => {
		$(document).ready(function () {
			$(".faq_question").click(function () {
				if ($(this).parent().is(".open")) {
					$(this).closest(".faq").find(".faq_answer_container").slideUp();
					$(this).closest(".faq").removeClass("open");
				} else {
					$(".faq_answer_container").slideUp();
					$(".faq").removeClass("open");
					$(this).closest(".faq").find(".faq_answer_container").slideDown();
					$(this).closest(".faq").addClass("open");
				}
			});
		});
	});
	return (
		<div>
			<Main_Page />
			<Page>
				<>
					<div class="faq_container">
						{/* <Stack vertical={true} > */}

						<Layout>
							{/* <span className="faq-padding"> */}
							<Layout.Section>
								<Card sectioned>
									<div class="faq">
										<div>
											<Heading>Quick Answers</Heading>
											<div class="faq_answer" style={{ marginTop: "10px" }}>
												You can find more answers and contact details in our support{" "}
												{/* <a href="javascript:$zopim.livechat.window.show();">
													Support
												</a> */}
											</div>
										</div>
									</div>
								</Card>
							</Layout.Section>
							{/* </span> */}
							<Layout.Section>
								<Card sectioned>
									<div class="faq">
										<div class="faq_question open">
											<Stack distribution="equalSpacing">
												<>Question goes here 1 ?</>
												<Icon source={ChevronDownMinor} />
											</Stack>
										</div>

										<div class="faq_answer_container">
											<div class="faq_answer">Answer goes here </div>
										</div>
									</div>
								</Card>
							</Layout.Section>

							<Layout.Section>
								<Card sectioned>
									<div class="faq">
										<div class="faq_question">
											<Stack distribution="equalSpacing">
												<>Question goes here 2 ?</>
												<Icon source={ChevronDownMinor} />
											</Stack>
										</div>
										<div class="faq_answer_container">
											<div class="faq_answer">Answer goes here</div>
										</div>
									</div>{" "}
								</Card>
							</Layout.Section>
							<Layout.Section>
								<Card sectioned>
									<div class="faq">
										<div class="faq_question">
											{" "}
											<Stack distribution="equalSpacing">
												<>Question goes here 3 ?</>
												<Icon source={ChevronDownMinor} />
											</Stack>
										</div>
										<div class="faq_answer_container">
											<div class="faq_answer">Answer goes here</div>
										</div>
									</div>{" "}
								</Card>
							</Layout.Section>
						</Layout>
						{/* </Stack> */}
					</div>
				</>
			</Page>
		</div>
	);
}
